import { Empty, Spin } from 'antd';
import React from 'react';
import { NUMBER_OF_SKELETON_CARDS, SCROLL_PERCENT } from '../common/constants';
import CommonCard from './CommonCard';

const InfiniteScrollHandler = (props) => {
  const {
    children,
    wrapperClassName,
    loading,
    refetchData,
    setScrollFlag,
    hasMore,
    scrollFlag,
    dataLength = 0,
    skeletonRows = 5,
    customDescription = 'No data',
  } = props;
  const handleScroll = (e) => {
    const { target } = e;
    const { scrollTop, scrollHeight, offsetHeight } = target || {};
    const scrolledToBottom =
      (scrollTop + offsetHeight) / scrollHeight >= SCROLL_PERCENT;
    if (scrolledToBottom && hasMore && !loading && !scrollFlag) {
      setScrollFlag(true);
      refetchData();
    }
  };
  return (
    <div
      className={`${
        wrapperClassName || 'common-scroll-wrapper'
      } position-relative`}
      onScroll={handleScroll}
    >
      <div className="full-width infinite-data-container">
        {dataLength > 0
          ? children
          : !loading && (
              <div className="full-width d-flex justify-center align-center">
                <Empty description={customDescription} />
              </div>
            )}
      </div>
      {loading &&
        (dataLength ? (
          <Spin spinning className="infinite-loader justify-center d-flex" />
        ) : (
          <>
            {[...Array(NUMBER_OF_SKELETON_CARDS)].map((record, index) => (
              <CommonCard
                loading
                // eslint-disable-next-line react/no-array-index-key
                key={`card-${index}`}
                className="skeleton-card"
                skeletonRows={skeletonRows}
              />
            ))}
          </>
        ))}
    </div>
  );
};
export default InfiniteScrollHandler;
